import "core-js/modules/es.array.iterator.js";
export const groupByProperty = (arr, property) => {
  return arr.reduce((acc, cur) => {
    acc[cur[property]] = [...(acc[cur[property]] || []), cur];
    return acc;
  }, {});
};